import { defaultColumns, defaultSort } from '../../components/data/ownCompanies/columns';

export default {
  state: {
    ownCompanies: [],
    tableConfig: null,
    loading: false,
  },
  getters: {
    ownCompanies: state => state.ownCompanies,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
  },
  mutations: {
    setOwnCompanies(state, ownCompanies) {
      state.ownCompanies = ownCompanies;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      commit('setLoading', true);
      try {
        const setting = await axios.get('api/table-settings/own-company-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'own-company-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'own-company-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetchAll({ commit }, queryString) {
      commit('setLoading', true);
      try {
        const setting = await axios.get('api/table-settings/own-company-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'own-company-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'own-company-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
        const ownCompanies = await axios.get('api/companies/own' + (queryString || ''));
        commit('setOwnCompanies', ownCompanies);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/companies/own/${id}`);
    },
    async create({ commit }, car) {
      await axios.post('api/companies/own', car);
    },
    async update({ commit }, car) {
      await axios.put('api/companies/own', car);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/companies/own/${id}`);
    },
  },
};
